import { memo } from "react";

import { Column } from "@bridgesplit/ui";
import { RoleView } from "@bridgesplit/abf-react";

import LendSettings from "./LendSettings";
import LendAmount from "./LendAmount";
import LendCta from "./LendCta";
import {
    useInitializeMarketLendCollateral,
    useInitializeMarketLendPresets,
    useInitializeMarketLendYieldSource
} from "./util";
import BorrowCapWarning from "../common/BorrowCapWarning";
import LendApyDuration from "./LendApyDuration";
import { useOpenGuideOnLoad } from "../util";
import LendLiteStats from "./LendLiteStats";
import { useMarketContext } from "../common";
import LendAdditionalInfo from "./LendAdditionalInfo";
import LendCollateralSelect from "./LendCollateralSelect";
import LendStats from "./LendStats";

export default memo(function LendCardContent() {
    useInitializeMarketLendCollateral();
    useInitializeMarketLendPresets();
    useInitializeMarketLendYieldSource();
    useOpenGuideOnLoad({ view: RoleView.Lend });

    const { isDialog } = useMarketContext();
    return (
        <Column spacing={3}>
            <LendAmount />
            {isDialog ? (
                <LendLiteStats />
            ) : (
                <>
                    <LendCollateralSelect />
                    <LendApyDuration />
                    <LendAdditionalInfo hide={true} />
                    <LendSettings />
                    <LendStats />
                </>
            )}
            <BorrowCapWarning />
            <LendCta />
        </Column>
    );
});
